import { Tooltip } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import BulkUploadIcon from "@/Components/Icons/BulkUploadIcon";
import { toggleBulkInvitedModal } from "@/reducers/client_candidates/candidatesinvited";
import { toggleOurServiceModal } from "@/reducers/clientcommon";
import { TOOLTIPTEXT } from "@/utilities/CommonText";

/**
 * Function for bulk inviting candidates.
 *
 * @return {JSX.Element} The button for bulk inviting candidates
 */
const BulkInvite = () => {
  const { isPremiumAccount } = useSelector((state) => state.session);
  const dispatch = useDispatch();
  return (
    <>
      <Tooltip title={TOOLTIPTEXT.bulkUpload}>
        <button
          className={`tour-invited-bulk-invites transition-linear flex h-[40px] items-center gap-[6px] rounded-lg border border-primary bg-lightblue px-4 font-semibold leading-[normal] text-primary hover:bg-primary hover:text-white focus:outline-none`}
          onClick={() => {
            if (isPremiumAccount) {
              dispatch(toggleBulkInvitedModal(true));
            } else {
              dispatch(toggleOurServiceModal(true));
            }
          }}
        >
          <BulkUploadIcon />
        </button>
      </Tooltip>
      {/* </Upload> */}
    </>
  );
};

export default BulkInvite;
